import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class AnalysisTableRequest extends CrudRequest {
  static baseUrl() {
    return 'account/analysis-table';
  }

  static get(document) {
    return httpService.get(
      this.baseUrl(),
      {
        params: {
          ClientDocument: document,
        },
      },
    );
  }

  static createObs(payload) {
    return httpService.post(
      `${this.baseUrl()}/observation`,
      payload,
    );
  }

  static listObs(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/observation`,
      {
        params,
      },
    );
  }

  static list(params = {}) {
    return httpService.get(
      'cliente/list-all',
      {
        params,
      },
    );
  }

  static getDocuments(params = {}) {
    return httpService.get(
      'cliente/cliente-arquivo/list-all',
      {
        params,
      },
    );
  }

  static upload(file, params = {}) {
    return this.makeFormDataRequest(
      'cliente/cliente-arquivo/add',
      {
        file,
      },
      {
        params,
      },
    );
  }

  static handleStatus(payload) {
    return httpService.patch(
      'cliente/situacao-cadastral',
      payload,
    );
  }

  static handleAccess(payload) {
    return httpService.patch(
      'cliente/situacao-acesso',
      payload,
    );
  }

  static uploadUserDocument(params, payload) {
    return httpService.post(
      'account/documents',
      payload,
      {
        params,
      },
    );
  }
}
